import { DotLottieReact } from "@lottiefiles/dotlottie-react";
import { FC } from "react";

const GridPage2: FC = () => {
	return (
		<div className="w-full min-h-dvh snap-start bg-white pt-[172px] flex flex-col md:flex-row-reverse gap-[45px] md:justify-between">
			<div className="h-full px-6 md:pl-0 md:pt-8 flex flex-col gap-6 md:pr-20 w-full max-w-[360px] items-center md:items-end">
				<p className="font-satoshi font-bold text-[24px] md:text-[36px] md:leading-[48px] leading-[28px] w-full md:w-[350px] text-[#1C1B1B] md:text-right">
					<span className="font-satoshi italic font-normal">Curo</span>{" "}
					structures and curates for you
				</p>
				<p className="font-satoshi font-normal text-base md:text-xl text-[#303030] w-full md:w-[350px] md:text-right">
					Create in-depth learning path. Curates the best content as you need.
				</p>
			</div>
			<div className="md:max-w-[600px] md:max-h-[416px] xl:max-h-[555px] xl:max-w-[800px] w-full px-[6px] md:px-0 rounded-tl-[32px] rounded-bl-[32px] flex items-center justify-center">
				<DotLottieReact src="/landingpage/Curo-Curates.json" loop autoplay />
			</div>
		</div>
	);
};

export default GridPage2;
